
export const downloadFile = (blobUrl, dowloadFileName) => {
    const tempLink = document.createElement('a')
    tempLink.href = blobUrl
    tempLink.setAttribute('download', dowloadFileName)
    document.body.appendChild(tempLink)
    tempLink.click()

    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobUrl)
}
